import {gql} from "@apollo/client";

export const CAR_DETAIL_FRAGMENT = gql`
    fragment CarDetail on CarType {
        id
        objectId
        registrationNo
        make
        model
        year
        variant
        procCategory
    }
`;

export const JOB_ROW_FRAGMENT = gql`
    fragment JobRow on JobRowType {
        id
        carPart{
            id
            name
        }
        subJobRow{
            id
            issue{
                id
                name
                initiatorPath
            }
            fixes{
                id
                name
            }
        }
    }
`;

export const MICRO_JOB_ROW_FRAGMENT = gql`
    fragment MicroJobRow on MicroJobRowType {
        id
        jobRow{
            id
        }
        part{
            id
            name
        }
        partCost
        labourCost
        partCount
        approvalStatus
        brand
        verification
        hsn{
            id
            code
        }
        sac{
            id
            code
        }
        fix{
            id
            name
        }
    }
    `;

    export const MICRO_JOB_ROW_FRAGMENT_V2 = gql`
    fragment MicroJobRow on MicroJobRowType {
        id
        jobRow{
            id
        }
        part:carPart{
            id
            name
        }
        jobCard{
            id 
        }
        issue{
            name
        }
        partCost
        labourCost
        partCount
        approvalStatus
        brand
        verification
        hsn{
            id
            code
        }
        sac{
            id
            code
        }
        fix:carPartFix{
            id
            name
            isPartRequired
        }
    }
    `;

    export const MICRO_JOB_ROW_AND_JOBROW_FRAGMENT_V2 = gql`
    fragment MicroJobRow on MicroJobRowType {
        id
        jobRow{
            ...JobRow
        }
        part:carPart{
            id
            name
        }
        jobCard{
            id 
        }
        partCost
        labourCost
        partCount
        approvalStatus
        brand
        verification
        hsn{
            id
            code
        }
        sac{
            id
            code
        }
        fix:carPartFix{
            id
            name
            isPartRequired
        }
        resolvedByType
        resolvedBy{
            name
            displayName
            id
        }
    }
    ${JOB_ROW_FRAGMENT}
    `;